"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ = require("_");

var _q = _interopRequireDefault(require("q"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _constants = require("./constants");

var API_BASE = 'hubs/v1/hubs';

var portalId = _hubspot.default.get();

var FormSettingsAPI =
/*#__PURE__*/
function () {
  function FormSettingsAPI() {
    (0, _classCallCheck2.default)(this, FormSettingsAPI);
  }

  (0, _createClass2.default)(FormSettingsAPI, null, [{
    key: "get",
    value: function get() {
      return _apiClient.default.get(API_BASE + "/" + portalId + "/settings");
    }
  }, {
    key: "set",
    value: function set(patch) {
      var style = Object.values(_constants.STYLE_SETTINGS || {}).reduce(function (memo, key) {
        return (0, _extends3.default)({}, memo, (0, _defineProperty2.default)({}, key, patch.get(key)));
      }, {});
      return _q.default.Promise.all([_apiClient.default.post(API_BASE + "/" + portalId + "/settings", {
        data: {
          hubId: portalId,
          internal: false,
          key: _constants.CREATE_EMAILLESS_CONTACT_KEY,
          value: patch.get(_constants.FORM_CREATE_EMAILLESS_CONTACT_ENABLED)
        }
      }), _apiClient.default.post(API_BASE + "/" + portalId + "/settings", {
        data: {
          hubId: portalId,
          internal: false,
          key: _constants.STYLE_SETTINGS_KEY,
          value: JSON.stringify(style)
        }
      })]).then(_.flatten);
    }
  }]);
  return FormSettingsAPI;
}();

exports.default = FormSettingsAPI;
module.exports = exports.default;